import { FolderStatus } from '../models/enums/folderStatus.enum';

export class BeneficiaryFilter {
  public nameOrCAF?: string;
  public firstName?: string;
  public birthDate?: Date;
  public supportTypeId?: number;
  public structureId?: number;
  public status?: FolderStatus;
  public referentId?: number;
  public searchFromCommunity: boolean = false;
  public searchRetroactive: boolean = false;

  public isEmpty(): boolean {
    return (
      this.nameOrCAF == undefined &&
      this.firstName == undefined &&
      this.birthDate == undefined &&
      this.supportTypeId == undefined &&
      this.structureId == undefined &&
      this.status == undefined &&
      this.referentId == undefined
    );
  }
}
